import {post} from '../utils/ajaxHelper';

/**
 * Handles POST to server for inquiry submission
 *
 * @param {*} inquiryModel
 * @param {*} locale
 * @param {*} useMockData
 */
function postInquiry(inquiryModel, locale, useMockData) {
    const variant = window && window.debugLog && window.debugLog.variant;
    const requestMarker = window && window.debugLog && window.debugLog.requestMarker;
    const url = useMockData
        ? `/pdp/inquiryRequest?useMockData=${useMockData}&useMockLogin=true`
        : `/pdp/inquiryRequest`;

    if (variant) {
        inquiryModel.variant = variant;
    }

    if (requestMarker) {
        inquiryModel.requestMarker = requestMarker;
    }

    inquiryModel.locale = locale;

    const headers = {'x-homeaway-site': window && window.__SITE_CONTEXT__.name};
    return post(url, inquiryModel, headers);
}

export default postInquiry;
export {postInquiry};
